var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.484,
    height: 42.859,
    viewBox: "0 0 34.484 42.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18638",
    "data-name": "Tracciato 18638",
    d: "M15.148,12.562V8.374H4.188V4.188H15.148V0H0V21.429A17.245,17.245,0,0,0,15.148,38.545v4.314h4.188V38.545A17.245,17.245,0,0,0,34.484,21.429V0H19.336V4.188H30.3V8.374H19.336v4.188H30.3v8.867a13.055,13.055,0,1,1-26.109,0V12.562Z",
    fill: "#fab725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.4aa901f14e84d4e3ad7e5ebab526d79c.svg";
export { ForwardRef as ReactComponent };